import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { getPriceScheduleSegmentAPI, getPriceScheduleSegmentByIdAPI } from '../../../api/schedules';
import { Constant } from '../../../config/constant';
import { ListScheduleState, PriceSegmentScheduleParams } from '../../../types/schedule';
import { RootState } from '../../store';

// @ts-ignore
export const getPriceScheduleSegment = createAsyncThunk(
  'admin/schedule/price-segment',
  async (params: PriceSegmentScheduleParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await getPriceScheduleSegmentAPI(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListPriceSchedule(data?.data));
        return true;
      }
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);
export const getPriceScheduleSegmentById = createAsyncThunk(
  'admin/schedule/price-segmentByID',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const response = await getPriceScheduleSegmentByIdAPI(id);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListPriceSegmentDetail(data?.data));
        return true;
      }
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);
export const priceScheduleSlice = createSlice({
  name: 'priceSchedule',
  initialState: {
    error: false,
    loading: false,
    success: false,
    loadingDetail: false,
    status: 0,
    listPriceSegment: [],
    listSegmentActive: [],
    listSegmentPriceSchedule: [],
    listPriceSegmentDetail: [],
    pagination: {
      total: 0,
      per_page: Constant.PAGE_SIZE,
      current_page: Constant.DEFAULT_PAGE,
      last_page: Constant.DEFAULT_PAGE,
    },
  } as ListScheduleState,
  reducers: {
    setListPriceSchedule: (state: ListScheduleState, { payload }) => {
      state.listPriceSegment = payload;
    },
    setListSegmentActive: (state: ListScheduleState, { payload }) => {
      state.listSegmentActive = payload;
    },
    resetListSegmentActive: (state: ListScheduleState) => {
      state.listSegmentActive = [];
    },
    setListSegmentPriceSchedule: (state: ListScheduleState, { payload }) => {
      state.listSegmentPriceSchedule = payload;
    },
    setListPriceSegmentDetail: (state: ListScheduleState, { payload }) => {
      state.listPriceSegmentDetail = payload;
    },
    resetListPriceSchedule: (state: ListScheduleState) => {
      state.listPriceSegment = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPriceScheduleSegment.pending, (state: ListScheduleState) => {
      state.loading = true;
    });
    builder.addCase(getPriceScheduleSegment.fulfilled, (state: ListScheduleState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getPriceScheduleSegment.rejected, (state: ListScheduleState) => {
      state.loading = false;
      state.success = false;
      state.error = true;
    });
    builder.addCase(getPriceScheduleSegmentById.pending, (state: ListScheduleState) => {
      state.loadingDetail = true;
    });
    builder.addCase(getPriceScheduleSegmentById.fulfilled, (state: ListScheduleState) => {
      state.loadingDetail = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getPriceScheduleSegmentById.rejected, (state: ListScheduleState) => {
      state.loadingDetail = false;
      state.success = false;
      state.error = true;
    });
  },
});

export const priceScheduleSelector = (state: RootState) => state.priceSchedule;
export const {
  setListPriceSchedule,
  resetListPriceSchedule,
  setListSegmentActive,
  setListSegmentPriceSchedule,
  setListPriceSegmentDetail,
  resetListSegmentActive,
} = priceScheduleSlice.actions;
